<template>
  <div class="area">
    <h1>Cambio de contraseña</h1>
    <h5>El cambio de contraseña tambien afecta a su cuenta de MAJAT</h5>
    <hr />
    <nuevaContrasena v-bind:requiereIngresarLaContrasenaActual="requiereIngresarLaContrasenaActual"></nuevaContrasena>
  </div>
</template>

<script>
  import nuevaContrasena from '@/components/Cuentas/Comun/Contrasena/NuevaContrasena.vue'

  export default {
    components: {
      nuevaContrasena
    },
    data() {
      return {
        requiereIngresarLaContrasenaActual: true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Tablero/Usuario/CambioDeContrasena.vue